import char1 from './char1.webp';
import char2 from './char2.webp';
import char3 from './char3.webp';
import char4 from './char4.webp';
import char5 from './char5.webp';
import char6 from './char6.webp';
import char7 from './char7.webp';
import char8 from './char8.webp';
import char9 from './char9.webp';
import char10 from './char10.webp';
import char11 from './char11.webp';
import char12 from './char12.webp';
import char13 from './char13.webp';
import char14 from './char14.webp';
import char15 from './char15.webp';

export const characterMap: Record<string, string> = {
  char1,
  char2,
  char3,
  char4,
  char5,
  char6,
  char7,
  char8,
  char9,
  char10,
  char11,
  char12,
  char13,
  char14,
  char15,
};

export const characterIds = Object.keys(characterMap);
